/* eslint-disable import/prefer-default-export */

export function filterParams(obj) {
  if (!obj) return {};
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null || obj[item] === undefined || obj[item] === '') delete obj[item];
  });
  return obj;
}

export function download(data, fileName = '导出报表.xls') {
  const sliceSize = 512;
  const byteCharacters = atob(data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  const file = new Blob(byteArrays, {
    type: 'application/vnd.ms-excel',
  });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.target = '_blank';
  a.click();
}



// WEBPACK FOOTER //
// ./src/utils/index.js